/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoHouseConstructionType = typeof ListingDetailResponseDtoHouseConstructionType[keyof typeof ListingDetailResponseDtoHouseConstructionType] | null;


export const ListingDetailResponseDtoHouseConstructionType = {
  BRICK: 'BRICK',
  WOODEN: 'WOODEN',
  PREFABRICATED: 'PREFABRICATED',
  MIXED: 'MIXED',
  BLOCK: 'BLOCK',
  OTHER: 'OTHER',
} as const;
